<div class="container padding-top padding-bottom">
  <md-card *ngIf="mobileSettings; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{clientData?.name}}</h1>
      </div>
      <div class="col-md-12">
        <h2>Mobile App Settings</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <md-slide-toggle [(ngModel)]="mobileSettings.requireLicensePhoto">Require License Photo When Renting a Unit
        </md-slide-toggle>
      </div>
    </div>

    <div class="row padding-top">
      <div class="col-md-12">
        <button style="float: right;"
                (click)="saveMobileSettings()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>

  </md-card>
</div>
<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/mobile-app-settings/mobile-app-settings.component.html